import { GET_GLOBAL_NOTES, LOADING } from 'core/actions/constants'
import { peachApi } from 'core/api'

const getGlobalNotes = ({ key, filters }) => {
  const { supercaseId } = filters
  return async dispatch => {
    if (key) {
      dispatch({
        type: LOADING,
        key,
        status: 'loading'
      })
    }

    try {
      const response = await peachApi.get({
        url: `/supercases/${supercaseId}/global-notes`
      })
      dispatch({ type: GET_GLOBAL_NOTES, payload: response.data })
      if (key) {
        dispatch({ type: LOADING, key, status: 'success' })
      }
      return response.data
    } catch {
      if (key) {
        dispatch({ type: LOADING, key, status: 'error' })
      }
    }
  }
}

export default getGlobalNotes
